import React from "react";
import { Box } from "@mui/material";

/**
 * Component to handle 404 page (not found routes)
 */
const NotFoundPage: React.FC = () => {
  // Show Coming Soon page when no distributorId
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        backgroundColor: "var(--color-background)",
        boxSizing: "border-box",
      }}
    ></Box>
  );
};

export default NotFoundPage;
